import { Typography } from '@mui/material';

import { formatNumber } from './utils/formatNumber';
import { useTooltipStyles } from './TooltipStyles';
import { IChartData } from '../../../Chart';
import {
  TranslationDateFn,
  TranslationNumberOrStringFn,
} from '../../../../types';

export interface TooltipProps {
  active?: boolean;
  translation: {
    date: TranslationDateFn;
    number?: TranslationNumberOrStringFn;
    time: TranslationDateFn;
  };
  payload?: Array<{
    value: number;
    payload: IChartData;
  }>;
}

export const Tooltip = ({
  active,
  payload,
  translation: { time, date, number = formatNumber },
}: TooltipProps) => {
  const { classes } = useTooltipStyles();

  const shouldHide = !(active && payload && payload.length > 0);

  if (shouldHide) return null;

  const item = payload[0].payload;

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <Typography variant="body2" className={classes.value}>
          {number(item.value || item.extraValue || 0)}
        </Typography>
      </div>
      <div className={classes.row}>
        <Typography variant="body1" className={classes.time}>
          {`${date(item.time)} ${time(item.time)}`}
        </Typography>
      </div>
    </div>
  );
};
